import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { SelectOption } from '@shared/models/multiselect-options.model';

export const countriesListActions = createActionGroup({
    source: 'Countries List',
    events: {
        'Get Countries List': emptyProps(),
        'Get Countries List Success': props<{ payload: SelectOption[] }>(),
        'Get Countries List Error': props<{ code: number }>(),
        Clear: emptyProps(),
    },
});
